module.exports = __webpack_public_path__ + "media/images/simple_search-de04da62e5c9eed8b5c1b53284c3590b.png";